import React from 'react';
import { Link } from 'react-router-dom';

// Material-UI
import CssBaseline from '@material-ui/core/CssBaseline';
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Divider from '@material-ui/core/Divider'
import IconDaftar from '@material-ui/icons/PersonAddRounded';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const ModalDaftar = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleClickOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };

    return (
      <section>
      <CssBaseline />
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
        size="large"
        fullWidth
        startIcon={<IconDaftar />}
      >
        {"Daftar"}
      </Button>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        
      >
        <DialogTitle id="alert-dialog-slide-title" style={{textAlign: "center"}}>
          {"Syarat Pendaftaran Mengikuti Kegiatan PCAB KSR PMI Unit Universitas Negeri Jakarta"}
        </DialogTitle>
          <Divider variant="middle" />
        <DialogContent>
          <DialogContentText>
            {"1. Mahasiswa UNJ Angkatan 2018-2020"}
          </DialogContentText>
          <DialogContentText>
            {"2. Mengunduh, kemudian mengisi formulir pendaftaran"}
          </DialogContentText>
          <DialogContentText>
            {"3. Melampirkan foto 3x4 (1 lembar) pada formulir pendaftaran"}
          </DialogContentText>
          <DialogContentText>
            {"4. Mengunggah formulir paling lambat tanggal 26 September 2020"}
          </DialogContentText>
        </DialogContent>
          <Divider variant="middle" />
        <DialogActions style={{textAlign: "center"}}>
          <Grid container spacing={2} >
            <Grid item xs={12}>
              <Link to="/registrasi" style={{textDecoration: "none", color: "white", width: "100%"}}>
                <Button variant="contained" color="primary" fullWidth size="large">
                    {"Saya Memenuhi Persyaratan"}
                </Button>
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Button variant="outlined" color="primary" onClick={handleClose} fullWidth size="large">
                  {"Saya Tidak Memenuhi Persyaratan"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      </section>
    )
}

export default ModalDaftar;

    
  